export type Trend = {
    key: string;
    value: number | string;
};

export type MetricLoadingStateSchema = {
    isLoading: boolean;
    isError: boolean;
    isFetched: boolean;
};

export type TrafficShareCompetitorSchema = {
    periodOverPeriodShareDifference: number;
    periodOverPeriodRankChange: number;
    yearOverYearShareDifference: number;
    yearOverYearRankChange: number;
    share: number;
    shareTrend: Trend[];
    rank: number;
};

export type TrafficShareMetricSchema = {
    primaryData: TrafficShareCompetitorSchema;
    competitorsData: Record<string, TrafficShareCompetitorSchema>;
    othersData: {
        share: number;
        periodOverPeriodShareRate: number;
        yearOverYearShareRate: number;
    };
} & MetricLoadingStateSchema;

export enum BenchmarkMetricName {
    //Overview
    trafficShare = "trafficShare",
    visits = "visits",
    audienceReach = "audienceReach",
    //Engagement
    visitDuration = "visitDuration",
    bounceRate = "bounceRate",
    pagesPerVisit = "pagesPerVisit",
    pageViews = "pageViews",
}

export enum MetricFormat {
    number = "number",
    numberAbbr = "numberAbbr",
    percent = "percent",
    percentSign = "percentSign",
    time = "time",
}
